import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import moment from 'moment'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  margin: 0;
  list-style: none;
`

const Container = styled.ul`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-column-gap: 0;
  grid-row-gap: 60px;
  margin: 0 auto;
  padding: 0;
  width: 100%;
  max-width: ${({ theme }) => theme.sizes.maxContentWidth};

  ${({ theme }) => theme.media.m} {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 60px;
    grid-row-gap: 70px;
  }

  ${({ theme }) => theme.media.xl} {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 80px;
    grid-row-gap: 80px;
  }
`

const PromotionItem = styled.li`
  position: relative;
  ${({ visible }) => !visible && 'display: none;'}
  width: 100%;
  transition: all 0.3s ease;

  > div {
    width: calc(100vw - 60px);
    height: calc(100vw - 60px);
    margin: 0 0 40px;
    background: center center url(${({ bg }) => bg}) no-repeat;
    background-size: cover;
  }

  h3 {
    margin: 0 0 10px;
    font-size: 22px;
  }

  > p {
    margin: 0 0 20px;
    font-size: 14px;
    font-weight: ${({ theme }) => theme.font.bold};
    color: ${({ theme }) => theme.colors.primary};
  }

  ${({ theme }) => theme.media.m} {
    :before {
      content: '';
      position: absolute;
      top: -20px;
      right: 0;
      width: 1px;
      height: 30px;
      background: ${({ theme }) => theme.colors.primary};
    }

    :nth-of-type(2n):before {
      display: none;
    }

    > div {
      width: 300px;
      height: 300px;
    }
  }

  ${({ theme }) => theme.media.xl} {
    :nth-of-type(2n):before {
      display: block;
    }

    :nth-of-type(3n):before {
      display: none;
    }
  }
`
const CurrentItem = styled.div`
  z-index: 900;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  transition: opacity 0.6s 0.3s ease;
  cursor: pointer;

  > img {
    height: 80%;
  }

  ${({ showed }) =>
    showed
      ? css`
          opacity: 1;
          pointer-events: auto;
        `
      : css`
          opacity: 0;
          pointer-events: none;
        `};
`

const PromotionsList = ({ promotionsList }) => {
  
  const [currentItem, setCurrentItem] = useState(0)
  const [currentItemShowed, setCurrentItemShowed] = useState(false)

  const handleClick = index => {
    console.log(promotionsList)
    setCurrentItem(index)
    setCurrentItemShowed(true)
  }

  const today = new Date()
  const dd = String(today.getDate()).padStart(2, '0')
  const mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
  const yyyy = today.getFullYear()

  const todayDate = `${yyyy}-${mm}-${dd}`

  return (
    <Wrapper>
      <Container>
        {promotionsList.map((item, index) => (
          <PromotionItem
            visible={moment(todayDate).isBetween(
              item.node.startDate,
              item.node.endDate,
              null,
              []
            )}
            key={item.node.id}
            bg={item.node.poster.childImageSharp.fluid.src}
            onClick={() => handleClick(index)}
          >
            <div />
            <h3>{item.node.name}</h3>
            <p>{(item.node.restaurants[0]) ? item.node.restaurants[0].Name : ''}</p>
          </PromotionItem>
        ))}
        {promotionsList.length !== 0 && (
        <CurrentItem
          showed={currentItemShowed}
          onClick={() => setCurrentItemShowed(false)}
        >
          {promotionsList[currentItem].node.poster !== undefined && (
            <img
              src={promotionsList[currentItem].node.poster.childImageSharp.fluid.src}
              alt="Promotion"
            />
          )}
        </CurrentItem>
      )}
      </Container>
    </Wrapper>
  )
}

export default PromotionsList
